import { EOrgType } from '@unfoldrtech/portal-mic'
import useGetAdvertiserReportingSearchTermsTableV3 from '../../../../hooks/use-get-advertiser-reporting-search-terms-table-v3'
import useGetRetailerReportingSearchTermsTableV3 from '../../../../hooks/use-get-retailer-reporting-search-terms-table-v3'

export const getTableSearchTermsFn = ({
  orgType = EOrgType.Advertiser,
}: {
  orgType?: EOrgType
}) => {
  let tableFn
  if (orgType === EOrgType.Advertiser) {
    tableFn = useGetAdvertiserReportingSearchTermsTableV3
  }
  if (orgType === EOrgType.Retailer) {
    tableFn = useGetRetailerReportingSearchTermsTableV3
  }

  return { tableFn }
}
